/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies
*/
import React from 'react';
import Progress from 'signer/components/common/progress';
import DotsLoader from 'signer/components/common/loader';
import createReactClass from 'create-react-class';

require('./index.scss');

const FullPageLoader = createReactClass({

  getDefaultProps() {
    return {
      message: 'Loading...',
    };
  },

  render() {

    let children;

    if (this.props.showDotsLoader) {
      children = <DotsLoader>
        { this.props.children }
      </DotsLoader>;
    } else {
      children = <Progress
        className='whitelabel-loader'
        onTweenedProgress={this.props.onTweenedProgress}
        progress={this.props.progress}
        loop={this.props.loop}
      >
        { this.props.children }
      </Progress>;
    }

    return (
      <div className='m-signer-mobile-loader'>
        { children }
      </div>
    );
  },
});

module.exports = FullPageLoader;
